<template>
	<div ref="laptop-job-search">
		<!-- <div
      style="
        position: fixed;
        top: 60px;
        z-index: 10000;
        left: 0px;
        backdrop-filter: blur(2px);
      "
      v-if="loader"
    >
      <Spinner />
    </div> -->

		<div
			class="cand-dashboard-maincontainer overflow-hidden"
			:class="!hasAccess() ? 'logout-cont' : ''"
		>
			<div class="js-main-container max-1825 gap-2">
				<div
					class="js-left-cont"
					:class="showBookmarked ? 'js-saved-left-cont' : ''"
				>
					<div v-if="!showBookmarked" class="new-custom-tab-sect d-flex p-0">
						<button
							class="tab flex-fill"
							:class="{ active: currentTab === 'hire' }"
							@click="switchTab('hire')"
						>
							<img
								src="../../assets/img/jobsearch/hire3x-mini-logo.svg"
								class="tab-icon mr-2"
								alt=""
							/>
							From Hire3x
						</button>
						<button
							v-if="!showBookmarked"
							class="tab flex-fill"
							:class="{ active: currentTab === 'curated' }"
							@click="switchTab('curated')"
						>
							<img
								src="../../assets/img/jobsearch/curated-img.svg"
								class="tab-icon mr-2 curated-icon"
								alt=""
							/>
							Curated Jobs
						</button>
					</div>

					<div
						class="shadow-sm"
						:class="{
							'tab-body': !showBookmarked,
							'hire-active': !showBookmarked && currentTab === 'hire',
							'curated-active': !showBookmarked && currentTab === 'curated',
						}"
					>
						<div @scroll="onScroll">
							<div
								class="d-flex align-items-center justify-content-between mt-4 mr-3 ml-3"
								v-if="!showBookmarked"
							>
								<div class="d-flex align-items-center js-search-cont">
									<div class="js-input w40 position-relative">
										<img
											class="js-search-pos"
											src="../../assets/newdesign/jobsearch/blueSearch.svg"
											alt=""
										/>
										<b-form-input
											placeholder="Search by skills, role"
											v-model="tempSearchQuery"
											type="search"
											@update="searchChanged"
											@keyup.enter="
												() => {
													tempSearchQuery && applyFilter();
												}
											"
										></b-form-input>
									</div>
									<div class="js-input w40 position-relative">
										<img
											class="js-search-pos"
											src="../../assets/newdesign/jobsearch/blueLocation.svg"
											alt=""
										/>
										<b-form-input
											placeholder="Location"
											v-model="tempLocations"
											type="search"
											@update="searchChanged"
											@keyup.enter="
												() => {
													tempLocations && applyFilter();
												}
											"
										></b-form-input>
									</div>
									<div
										@click.stop="toggleFilter"
										class="w20 d-flex align-items-center justify-content-center pointer js-blue-txt white-space-no-wrap"
									>
										<div class="position-relative mr-2">
											<img
												class=""
												src="../../assets/newdesign/jobsearch/morefilters.svg"
												alt=""
											/>
											<div
												v-if="isFiltered"
												style="right: 0px"
												class="laptop-filter-dot"
											></div>
										</div>
										More Filters
									</div>
								</div>
								<b-button
									class="candash-addBtn"
									:disabled="!isSearchChanged"
									@click="applyFilter"
									>Search</b-button
								>

								<div v-if="hasAccess()">
									<img
										v-b-tooltip.hover="'Saved Jobs'"
										v-if="showBookmarked == false"
										@click="toggleBookmarkedFilter"
										class="blueShadow pointer"
										src="../../assets/newdesign/jobsearch/roundBookmark.svg"
										alt=""
									/>
									<img
										v-b-tooltip.hover="'Saved Jobs'"
										v-else
										@click="toggleBookmarkedFilter"
										class="blueShadow pointer"
										src="../../assets/newdesign/jobsearch/roundBookmarked.svg"
										alt=""
									/>
									<img
										v-b-tooltip.hover="'Applied Jobs'"
										class="blueShadow pointer ml-2"
										src="../../assets/newdesign/jobsearch/round-case.svg"
										alt=""
										@click="goToJobProgress"
									/>
								</div>
							</div>
							<div class="pl-3" :class="{ 'pt-3': !showBookmarked }">
								<div class="js-black-txt">
									<div
										class="border-bottom d-flex align-items-center justify-content-between pb-2"
									>
										<div>
											<div
												v-if="loader && (!jobs || !jobs.length)"
												class="my-2"
											></div>
											<div
												v-else-if="
													(searchQuery || locations || bookmarkedSearchQuery) &&
													total > 0
												"
											>
												Showing {{ total }} jobs that matches your search result
											</div>
											<div v-else-if="isFiltered && total > 0">
												Showing {{ total }} jobs that matches your filter
											</div>
											<div v-else-if="jobs && jobs.length > 0">
												{{
													showBookmarked
														? "You have saved " + jobs.length + " jobs"
														: "List of Jobs"
												}}
											</div>
										</div>
										<div class="position-relative w40" v-if="showBookmarked">
											<img
												class="resumes-search-image-position"
												src="../../assets/headerSearch.svg"
												alt=""
											/>
											<b-form-input
												class="resumes-search-input"
												placeholder="Search Job"
												debounce="500"
												v-model="bookmarkedSearchQuery"
												@update="searchJobs($event, false)"
												type="search"
												clearable
											>
											</b-form-input>
										</div>
										<div
											class="position-relative mr-4"
											v-if="
												!showBookmarked &&
												!isFiltered &&
												!searchQuery &&
												!locations &&
												!bookmarkedSearchQuery &&
												!loader
											"
										>
											<span class="job-count mb-grey-txt"
												>Total Jobs: {{ total }}</span
											>
										</div>
									</div>
								</div>
								<div
									id="jobs"
									@scroll="onScroll"
									:class="
										showBookmarked
											? 'js-overflow-2'
											: jobs && jobs.length == 0
											? 'js-overflow-empty'
											: 'js-overflow'
									"
									class="mt-2 pr-2"
								>
									<template v-if="loader && (!jobs || !jobs.length)">
										<div
											v-for="index in 10"
											:key="index"
											class="js-cards mb-2 pointer"
										>
											<div class="d-flex">
												<div style="height: 35px; width: 35px">
													<b-skeleton
														class="h-100 w-100"
														type="avatar"
													></b-skeleton>
												</div>
												<div class="width-93 pl-2">
													<b-skeleton class="w-50 mt-1"></b-skeleton>
													<b-skeleton class="w-75 mt-3"></b-skeleton>
													<b-skeleton class="w-100 mt-3"></b-skeleton>
													<b-skeleton class="w-100 mt-3"></b-skeleton>
												</div>
											</div>
										</div>
									</template>
									<template v-else-if="jobs && jobs.length">
										<div
											v-for="(job, index) in jobs"
											:key="index"
											class="mb-2 pointer"
											:class="[
												showSidePanel && selectedJob.jobID === job.jobID
													? 'js-selected-card'
													: 'js-cards',
											]"
											@click.stop="showJobDetails(job)"
										>
											<div
												class="d-flex justify-content-between align-items-baseline px-2 w-100"
											>
												<div class="d-flex w59">
													<div class="mr-3">
														<img
															src="../../assets/newdesign/jdprogress/trans-DP.svg"
															alt=""
														/>
													</div>
													<div class="w-90">
														<div class="mb-header-txt text-truncate w-100">
															{{ toTitleCase(job.title) }}
														</div>
														<div
															class="asp-grey-txt-4 mt-1 text-truncate w-100"
														>
															{{
																job.customFields.private_job
																	? job.customFields.Board_Organization
																	: job.customerName
															}}
														</div>
													</div>
												</div>
												<div class="d-flex align-items-center">
													<div
														v-if="job.fastFillingJob"
														class="js-fast-filling d-flex align-items-center mr-3"
													>
														<img
															class="mr-2"
															src="../../assets/newdesign/jobsearch/fastfilling.svg"
															alt=""
														/>
														Fast Filling Job
													</div>
													<div
														class="mb-grey-txt d-flex align-items-center mr-2"
													>
														<img
															class="mr-1"
															src="../../assets/newdesign/jobsearch/blueClock.svg"
															alt=""
														/>
														{{ job.postedAt }}
													</div>
													<div v-if="!job.isCurated">
														<img
															v-if="job.bookmarked"
															@click.stop="
																!hasAccess()
																	? openLoginModal()
																	: toggleBookmark(job)
															"
															src="../../assets/newdesign/jobsearch/filledBookmark.svg"
															alt=""
														/>
														<img
															v-else
															@click.stop="
																!hasAccess()
																	? openLoginModal()
																	: toggleBookmark(job)
															"
															src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
															alt=""
														/>
													</div>
												</div>
											</div>
											<div
												class="d-flex align-items-start cd-hs-pi-sh-2 w-100 jdp-pl-48px mt-2"
											>
												<div
													class="d-flex align-items-center"
													style="white-space: nowrap"
													v-if="job.experienceRequired"
												>
													<img
														class="mr-2"
														src="../../assets/newdesign/dashboard/blueMail2.svg"
														alt=""
													/>{{ job.experienceRequired }} Years
												</div>
												<div
													v-if="job.experienceRequired"
													class="jdp-dot m-2"
												></div>
												<template v-if="job.jobType && !job.isCurated">
													<div
														class="d-flex align-items-center"
														style="white-space: nowrap"
													>
														<img
															class="mr-2"
															src="../../assets/newdesign/jdprogress/trans-fulltime.svg"
															alt=""
														/>{{ toTitleCase(job.jobType) }}
													</div>
													<div class="jdp-dot m-2"></div>
												</template>
												<div class="text-break d-flex align-items-start w-50">
													<img
														class="mr-1"
														src="../../assets/newdesign/dashboard/blueLocation.svg"
														alt="Location Icon"
													/>
													<span>{{ job.location[0] }}</span>
													<span v-if="job.location.length > 1"
														>, {{ job.location[1] }}</span
													>
													<span
														class="viewmore-grey ml-1 pointer"
														v-if="job.location.length > 2"
													>
														+{{ job.location.length - 2 }} more
													</span>
												</div>
											</div>
											<div class="d-flex justify-content-between w-100">
												<div
													class="d-flex align-items-start cd-hs-pi-sh-2 jdp-pl-48px w80 mt-2"
												>
													<template v-if="!job.isCurated">
														<div class="jdp-haze-text">Skills :</div>

														<div
															v-if="job.skills.length > 0"
															class="ml-2 w-91 text-break"
														>
															<span
																v-for="(skill, index) in job.skills"
																v-show="index < 4"
																:key="index"
															>
																<span
																	v-html="highlightedSkillsDash(skill)"
																></span>
																<span
																	v-if="
																		index < 3 && index < job.skills.length - 1
																	"
																	>,
																</span>
															</span>
															<span
																class="viewmore-grey ml-1 pointer"
																v-if="job.skills.length > 4"
															>
																+{{ job.skills.length - 4 }} more
															</span>
														</div>
														<span v-else class="text-d9d9d9 ml-2"
															>Not Mentioned</span
														>
													</template>
												</div>

												<div>
													<b-button
														v-if="!job.jobApplied && !job.addedByRecruiter"
														class="candash-addBtn-js"
														@click.stop="
															!hasAccess()
																? openLoginModal()
																: job.customFields.gov_job ||
																  job.customFields.private_job
																? openGovtJobModal(job)
																: openApplyJobModal(job)
														"
														>Apply
														<img
															class="ml-2"
															src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
															alt=""
													/></b-button>
													<b-button v-else class="candash-addBtn-js">
														<img
															class="mr-2"
															src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
															alt=""
														/>
														Applied
													</b-button>
												</div>
											</div>
										</div>
									</template>
									<div
										v-else
										class="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
									>
										<template v-if="isFiltered">
											<img
												src="../../assets/newdesign/jobsearch/searchNotFound.svg"
												alt=""
											/>
											<span class="js-empty-font mt-3">
												No matching results found for the filter.
											</span>
										</template>
										<template
											v-else-if="
												(!showBookmarked && (searchQuery || locations)) ||
												(showBookmarked && bookmarkedSearchQuery)
											"
										>
											<img
												src="../../assets/newdesign/jobsearch/searchNotFound.svg"
												alt=""
											/>
											<span class="js-empty-font mt-3">
												No matching result for "{{
													showBookmarked
														? bookmarkedSearchQuery
														: [searchQuery, locations]
																.filter((a) => a)
																.join(", ")
												}}"
											</span>
										</template>
										<template v-else>
											<img
												src="../../assets/newdesign/jobsearch/noSavedJobs.svg"
												alt=""
											/>
											<span class="js-empty-font">
												There are no
												{{ showBookmarked ? "saved" : "" }}
												jobs.
											</span>
										</template>
									</div>
									<div>
										<div
											v-if="loadingMore"
											class="d-flex justify-content-center"
										>
											<b-spinner label="Loading..."></b-spinner>
										</div>
									</div>
								</div>
							</div>
							<!-- End of class="pl-3" -->
						</div>
						<!-- End of @scroll="onScroll" -->
					</div>
					<!-- End of tab-body -->
				</div>
				<article class="js-right-cont w-30">
					<div
						class="Update-box d-flex align-items-center justify-content-between mb-3"
						v-if="showPreferences"
					>
						<div
							class="d-flex gap-2 align-items-center pointer"
							@click="
								!hasAccess() ? openLoginModal() : (showJobPreferance = true)
							"
						>
							<img src="../../assets/img/jobsearch/filter-job.svg" alt="" />
							<div>Update Job Preferences</div>
						</div>
						<div class="pointer" @click="showJobPreferance = true">
							<img
								src="../../assets/icons/candidatedashboard/canddashright/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>
					<JobAlert class="mb-3" :isPersistent="!hasAccess()" />
					<div
						class="js-purple-card"
						v-if="searchHistory && !searchHistory.length"
					>
						<div class="js-purple-txt mt-4 text-center">
							Own Your Skills, Own Your Success:
						</div>
						<div class="js-purple-txt-2 text-center">Start a Course Today.</div>
						<img
							class="w-100"
							src="../../assets/newdesign/jobsearch/5in1Svg.svg"
							alt=""
						/>
					</div>

					<div class="rotating-border" v-if="!showPreferences">
						<div class="card-content">
							<img
								src="@/assets/job-search-icons/jobpref-topicon.svg"
								class="jobref-topicon w-100"
								alt=""
							/>
							<div class="js-grey-txt">
								Set the job preference to get right recommended jobs
							</div>
							<div class="jobpref-subheads mt-2">
								Let us know your job preferences, so we can match you with the
								best opportunities.
							</div>
							<div class="d-flex w-100 justify-content-end mt-3">
								<b-button
									style="z-index: 2"
									class="candash-addBtn setupbtn"
									@click="
										!hasAccess() ? openLoginModal() : (showJobPreferance = true)
									"
									>Set-up</b-button
								>
							</div>
						</div>
					</div>

					<div
						class="js-right-second-card p-3 mt-11px"
						v-if="searchHistory && searchHistory.length"
					>
						<img
							class="firstside-pos"
							src="../../assets/newdesign/jobsearch/secondSide.svg"
							alt=""
						/>
						<div class="js-grey-txt">People also searched:</div>
						<div class="js-first-overflow d-flex flex-wrap mt-2">
							<div
								v-for="i in searchHistory"
								:key="i"
								class="js-blue-search-cards mb-2 mr-2 pointer"
								@click="jobSearch(i)"
							>
								<img
									class="mr-2 flex-shrink-0"
									src="../../assets/newdesign/jobsearch/whitesearch.svg"
									alt=""
								/>
								<span class="js-search-tag-text">{{ i }}</span>
							</div>
						</div>
					</div>
					<div class="js-right-third-card p-3 mt-11px" v-if="assessLoader">
						<img
							class="firstside-pos"
							src="../../assets/newdesign/jobsearch/thirdSide.svg"
							alt=""
						/>
						<div class="js-grey-txt">Assessments</div>

						<div class="mt-2 position-relative z-ind-2">
							<AssessmentCardSkeleton
								v-for="assess in 3"
								:key="assess"
								customClass="p-3 mb-2"
								:customStyle="{
									background: '#fcfcfc',
									borderRadius: '8px',
									boxShadow: '0px 2px 8px #00000014',
								}"
							/>
						</div>
					</div>
					<div
						class="js-right-third-card p-3 mt-11px"
						v-else-if="!assessLoader && assessments.length > 0"
					>
						<img
							class="firstside-pos"
							src="../../assets/newdesign/jobsearch/thirdSide.svg"
							alt=""
						/>
						<div class="js-grey-txt">Assessments</div>
						<div class="mt-2 position-relative z-ind-2">
							<AssessmentCard
								v-for="(data, i) in assessments"
								:key="i"
								:assessment="data"
								:fromAsmntprogress="false"
								fromJobSearch="main"
								:fromJobSearchpage="true"
								class="mb-2"
							/>
						</div>
						<div
							class="d-flex justify-content-center w-100 js-underline-txt-2 pointer"
							@click="goToAssessment"
						>
							View All Assessments
						</div>
					</div>
				</article>
			</div>
			<Transition name="slide">
				<div v-if="showFilter" class="js-trans-main-cont w40" ref="filter">
					<div class="js-trans-top">
						<div
							class="d-flex align-items-center justify-content-between position-relative"
						>
							<img
								@click="toggleFilter"
								class="transArrow-pos"
								src="../../assets/newdesign/jdprogress/transBackArrow.svg"
								alt=""
							/>
							<div class="candash-modal-label-3 pl-4">More Filters</div>

							<div>
								<img
									@click="toggleFilter"
									class="pointer"
									src="../../assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
						<hr class="hr-back" />
						<div class="js-trans-overflow">
							<div class="js-trans-left">
								<div
									v-for="(filter, key) in filteredTabs"
									:key="key"
									class="pointer"
									:class="
										currentFilterTab === key
											? 'js-selected-filter'
											: 'js-normal-filter'
									"
									@click="currentFilterTab = key"
								>
									{{ filter.text }}
								</div>
							</div>
							<div class="js-trans-right">
								<div
									class="laptop-group mob-checkbox-group"
									v-if="FILTER_TABS[currentFilterTab].isMulti"
								>
									<b-form-group>
										<b-form-checkbox
											size="sm"
											v-for="option in FILTER_TABS[currentFilterTab].isDynamic
												? dynamicFilters[currentFilterTab]
												: toDropdownOptions(
														FILTER_TABS[currentFilterTab].options
												  )"
											v-model="tempFilters[currentFilterTab]"
											:key="option.value"
											:value="option.value"
										>
											{{ option.text }}
										</b-form-checkbox>
									</b-form-group>
								</div>
								<div
									class="laptop-group p-2"
									v-else-if="
										currentFilterTab === 'minSalary' && currentTab === 'curated'
									"
								>
									<div class="mb-3 fs-14 mb-grey-txt-2">Salary more than:</div>
									<div class="d-flex align-items-center w-100">
										<button
											class="btn p-0 d-flex align-items-center justify-content-center shadow-none w-32 h-32 fs-16 salary-button"
											:style="{
												backgroundColor:
													(Number(tempFilters.minSalary) || 0) > 0
														? '#1b5b97'
														: '#bac9d8',
											}"
											@click.prevent="
												tempFilters.minSalary = Math.max(
													0,
													(Number(tempFilters.minSalary) || 0) - 10000
												)
											"
										>
											-
										</button>
										<b-form-input
											type="text"
											:value="(tempFilters.minSalary || 0) + ' Rs'"
											@input="
												(val) =>
													(tempFilters.minSalary = Number(
														val.replace(/\D/g, '')
													))
											"
											@keypress="
												(e) => {
													if (
														e.key !== 'Backspace' &&
														e.key !== 'Delete' &&
														!/[0-9]/.test(e.key)
													)
														e.preventDefault();
												}
											"
											class="mx-2 text-center flex-grow-1 w-100 salary-input"
										></b-form-input>
										<button
											class="btn p-0 d-flex align-items-center justify-content-center shadow-none w-32 h-32 fs-16 salary-button"
											style="background-color: #1b5b97"
											@click.prevent="
												tempFilters.minSalary =
													(Number(tempFilters.minSalary) || 0) + 10000
											"
										>
											+
										</button>
									</div>
								</div>
								<div class="laptop-group mob-radio-group" v-else>
									<b-form-group>
										<b-form-radio-group
											size="sm"
											:options="
												FILTER_TABS[currentFilterTab].isDynamic
													? dynamicFilters[currentFilterTab]
													: toDropdownOptions(
															FILTER_TABS[currentFilterTab].options
													  )
											"
											v-model="tempFilters[currentFilterTab]"
											value-field="value"
											text-field="text"
											stacked
										></b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</div>
					</div>
					<div
						class="pt-2 d-flex align-items-center justify-content-between border-top px-3"
					>
						<div>
							<b-button
								class="candash-cancelBtn"
								:disabled="!isFilterChanged && !isFiltered"
								@click="resetFilter"
								>Reset</b-button
							>
						</div>
						<div class="d-flex align-items-center">
							<b-button class="candash-cancelBtn mr-3" @click="toggleFilter"
								>Cancel</b-button
							>
							<b-button
								class="candash-addBtn-js"
								:disabled="!isFilterChanged"
								@click="applyFilter"
								>Search</b-button
							>
						</div>
					</div>
				</div>
			</Transition>
			<Transition name="slide">
				<div
					v-if="showSidePanel && selectedJob && !selectedJob.isCurated"
					ref="job-details"
					class="w-50 jdprog-trans-main-cont"
				>
					<div
						class="d-flex align-items-center justify-content-between position-relative"
					>
						<img
							@click="toggleSidePanel"
							class="transArrow-pos"
							src="../../assets/newdesign/jdprogress/transBackArrow.svg"
							alt=""
						/>

						<div class="candash-modal-label-3 pl-4">Job Details</div>
						<div class="d-flex align-items-center" v-if="!jobShimmer">
							<!-- <div
								class="mb-resume-name pointer d-flex align-items-center"
								v-if="selectedJob.jobApplied"
								@click="showWithdrawApplication(selectedJob)"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/withdrawApplication.svg"
									alt=""
								/>Withdraw Application
							</div> -->
							<div
								class="asp-vertical-line ml-3 mr-3"
								v-if="selectedJob.jobApplied"
							></div>
							<div>
								<img
									@click="toggleSidePanel"
									class="pointer"
									src="../../assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
					<hr class="hr-back" />
					<div class="jdp-trans-overflow-2 w-100 pl-1">
						<div class="d-flex w-100 pl-3">
							<div style="height: 35px; width: 35px" v-if="jobShimmer">
								<b-skeleton class="h-100 w-100" type="avatar"></b-skeleton>
							</div>
							<div v-else>
								<img
									src="../../assets/newdesign/jdprogress/trans-DP.svg"
									alt=""
								/>
							</div>
							<div class="ml-3 width-94">
								<div
									class="d-flex align-items-start justify-content-between w-100"
								>
									<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
									<div class="jdp-black-txt-3 text-break w-60" v-else>
										{{ toTitleCase(selectedJob.title) }}
									</div>
									<div
										class="d-flex align-items-center gap-3 pr-2"
										v-if="!jobShimmer"
									>
										<b-button
											style="width: 98px !important"
											class="candash-cancelBtn-js"
											@click="
												!hasAccess()
													? openLoginModal()
													: toggleBookmark(selectedJob)
											"
										>
											<img
												v-if="selectedJob.bookmarked"
												class="mr-2"
												src="../../assets/newdesign/jobsearch/button-bookmark-filled.svg"
												alt=""
											/>
											<img
												v-else
												class="mr-2"
												src="../../assets/newdesign/jobsearch/button-bookmark.svg"
												alt=""
											/>{{ selectedJob.bookmarked ? "Saved" : "Save" }}
										</b-button>
										<b-button
											v-if="
												!selectedJob.jobApplied && !selectedJob.addedByRecruiter
											"
											@click="
												!hasAccess()
													? openLoginModal()
													: (selectedJob.customFields &&
															selectedJob.customFields.gov_job) ||
													  (selectedJob.customFields &&
															selectedJob.customFields.private_job)
													? openGovtJobModal(selectedJob)
													: openApplyJobModal(selectedJob)
											"
											class="candash-addBtn-js"
											style="padding: 4px 18px !important"
										>
											Apply

											<img
												class="ml-2"
												src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
												alt=""
										/></b-button>
										<b-button
											v-else
											class="candash-addBtn-js"
											style="padding: 4px 18px !important"
										>
											<img
												class="mr-2"
												src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
												alt=""
											/>
											Applied
										</b-button>
									</div>
								</div>
								<b-skeleton class="w-33" v-if="jobShimmer"></b-skeleton>
								<div
									class="mt-2 text-truncate w-100 d-flex align-items-center"
									v-else
								>
									<div class="asp-grey-txt-5 w-80">
										{{
											selectedJob.customFields.private_job
												? selectedJob.customFields.Board_Organization
												: selectedJob.customerName
										}}
									</div>
									<div
										class="w-20 d-flex justify-content-end"
										v-if="selectedJob.customFields.gov_job"
									>
										<div class="ja-govtjob-tag">
											<img
												src="@/assets/job-search-icons/govt-tag.svg"
												class="mr-1"
												alt=""
											/>Government Job
										</div>
									</div>
								</div>
								<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
								<div class="cd-hs-pi-sh-2 d-flex align-items-start mt-2" v-else>
									<div
										class="d-flex align-items-center mr-4 max-w60 text-break"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-location.svg"
											alt=""
										/>
										{{
											selectedJob.location.length > 0
												? selectedJob.location[0]
												: ""
										}}
										<span
											v-if="selectedJob.location.length > 1"
											@click="scrollToChild('child2')"
											class="viewmore-grey ml-1 pointer"
											>+{{ selectedJob.location.length - 1 }} more</span
										>
									</div>
									<div
										class="d-flex align-items-center mr-4"
										v-if="selectedJob.experienceRequired"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/dashboard/blueMail2.svg"
											alt=""
										/>{{
											selectedJob.experienceRequired === "others"
												? "12+"
												: selectedJob.experienceRequired
										}}
										Years
									</div>
									<div
										class="d-flex align-items-center"
										v-if="selectedJob.jobType"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-fulltime.svg"
											alt=""
										/>{{ toTitleCase(selectedJob.jobType) }}
									</div>
								</div>
								<b-skeleton class="w-80" v-if="jobShimmer"></b-skeleton>
								<div
									class="d-flex align-items-baseline justify-content-between"
								>
									<div
										class="d-flex align-items-start cd-hs-pi-sh-2 mt-2 mr-3"
										v-if="!selectedJob.isCurated"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-skill.svg"
											alt=""
										/>
										<span v-if="selectedJob.skills"
											>{{ selectedJob.skills.slice(0, 4).join(", ") }}
											<span
												v-if="selectedJob.skills.length > 4"
												@click="scrollToChild('child1')"
												class="viewmore-grey ml-1 pointer"
												>+{{ selectedJob.skills.length - 4 }} more</span
											></span
										>
										<span v-else class="text-d9d9d9">Not Mentioned</span>
									</div>
									<div
										class="d-flex align-items-start mb-grey-txt mt-2 mr-2 white-space-no-wrap"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-posted.svg"
											alt=""
										/>{{ selectedJob.postedAt }}
									</div>
								</div>
							</div>
						</div>

						<section
							class="jobapply-box d-flex align-items-center mt-3"
							v-if="getgovtids.includes(selectedJob.jobID)"
						>
							<div class="w-84">
								<div class="mb-black-bold-4">Did you Apply?</div>
								<div class="jobapplysubtext">
									Let us know and we will help you track your application
								</div>
							</div>
							<div class="w-8 text-center">
								<div
									class="jobapplybox-btns pointer"
									@click="appliedGovtjob(selectedJob.jobID,selectedJob)"
								>
									Yes
								</div>
							</div>
							<div class="w-8 text-center">
								<div
									class="jobapplybox-btns pointer"
									@click="removeGovtid(selectedJob.jobID)"
								>
									No
								</div>
							</div>
						</section>
						<b-skeleton class="w-33 mt-3" v-if="jobShimmer"></b-skeleton>
						<div class="mb-black-bold-4 mt-4" v-else>Job Description</div>
						<b-skeleton class="w-100 h-30 mt-3" v-if="jobShimmer"></b-skeleton>
						<div
							v-else
							class="mb-grey-txt-2 pr-3 mb-2"
							v-html="selectedJob.description"
						></div>
						<template v-if="jobShimmer">
							<div class="d-flex w-100 justify-content-between">
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
							</div>
							<hr class="hr-back" />
							<div class="d-flex w-100 justify-content-between">
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
							</div>
						</template>
						<template v-if="!jobShimmer">
							<div class="d-flex">
								<div
									class="w-50"
									v-if="selectedJob.minSalary && selectedJob.minSalary > 0"
								>
									<div class="mb-black-bold">Minimum CTC</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.minSalary }} LPA
									</div>
								</div>
								<div
									class="w-50"
									v-if="selectedJob.maxSalary && selectedJob.maxSalary > 0"
								>
									<div class="mb-black-bold">Maximum CTC</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.maxSalary }} LPA
									</div>
								</div>
							</div>
							<hr
								class="hr-back"
								v-if="selectedJob.openingsCount || selectedJob.gender"
							/>
							<div class="d-flex">
								<div class="w-50" v-if="selectedJob.openingsCount">
									<div class="mb-black-bold">No. of Openings</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.openingsCount }}
									</div>
								</div>
								<div class="w-50" v-if="selectedJob.gender">
									<div class="mb-black-bold">Gender</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.gender }}
									</div>
								</div>
							</div>
							<hr class="hr-back" />
							<div
								class="d-flex"
								v-if="
									selectedJob.educationQualification ||
									(selectedJob.customFields &&
										selectedJob.customFields &&
										selectedJob.customFields.shift)
								"
							>
								<div class="w-50" v-if="selectedJob.educationQualification">
									<div class="mb-black-bold">Education</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.educationQualification }}
									</div>
								</div>
								<div
									class="w-50"
									v-if="
										selectedJob.customFields &&
										selectedJob.customFields &&
										selectedJob.customFields.shift
									"
								>
									<div class="mb-black-bold">Shift</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.customFields.shift || "-" }}
									</div>
								</div>
							</div>
							<hr class="hr-back" v-if="selectedJob.workingTime" />
							<div class="d-flex">
								<!-- <div class="w-50">
                  <div class="mb-black-bold">Work Type</div>
                  <div class="mb-grey-txt-2 mt-1">Remote</div>
                </div> -->
								<div class="w-50" v-if="selectedJob.workingTime">
									<div class="mb-black-bold">Working Hours</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.workingTime }}
									</div>
								</div>
							</div>
							<hr class="hr-back" v-if="selectedJob.noticePeriod" />
							<div class="d-flex" v-if="selectedJob.noticePeriod">
								<div class="w-50">
									<div class="mb-black-bold">Notice Period</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.noticePeriod }}
									</div>
								</div>
							</div>
							<hr class="hr-back" />
							<div ref="child2" class="mb-black-bold">Locations</div>
							<div class="mb-grey-txt-2 mt-1">
								{{ arrayToString(selectedJob.location) }}
							</div>
							<hr class="hr-back" />
							<div ref="child1" class="mb-black-bold" v-if="selectedJob.skills">
								Skills
							</div>
							<div class="mb-grey-txt-2 mt-1" v-if="selectedJob.skills">
								<span v-html="highlightedSkills(selectedJob.skills)"></span>
							</div>
							<template v-if="selectedJob.skillsToLearn">
								<div
									class="d-flex align-items-center justify-content-between mt-4"
								>
									<div class="mb-black-bold">
										Skills you need to prepare on for this Job:
									</div>
									<!-- <div class="d-flex align-items-center jdp-blue-txt-2 mr-2">
										Gathered by Hire3x
										<img
											class="ml-1"
											src="../../assets/newdesign/jdprogress/trans-AI.svg"
											alt
										/>
									</div> -->
									<b-button
										@click="!hasAccess() ? openLoginModal() : openJobMatch()"
										class="candash-addBtn-js"
										>Check job match</b-button
									>
								</div>
								<div class="jdp-italic-text-2">
									Increase your chances of getting hired by 2x
								</div>
								<div class="d-flex flex-wrap mt-1">
									<div
										v-for="(skill, index) in selectedJob.skillsToLearn"
										:key="index"
										class="jdp-skill-tag mr-2 mb-2"
									>
										{{ skill }}
									</div>
								</div>
							</template>
						</template>
						<template>
							<div class="mb-black-bold mt-3">
								Practice for the job inteview
							</div>
							<div class="d-flex gap-4 pr-2 mt-2">
								<div
									class="flex-1 d-flex align-items-center justify-content-between gap-2 interview-card pointer"
									@click="
										!hasAccess()
											? openLoginModal()
											: goToMockInterview(selectedJob)
									"
								>
									<div class="flex-1 d-flex align-items-center gap-3">
										<img
											src="../../assets/newdesign/jobsearch/take-mock.svg"
											alt=""
										/>
										<div>
											<div class="fam-mont fw-M fs-14 text-blue">
												Take Mock Interview
											</div>
											<div class="fam-lato fw-R fs-12 text-headtext mt-1">
												Learn practical, in-demand skills to stay ahead in your
												career journey.
											</div>
										</div>
									</div>
									<img
										height="24"
										width="24"
										src="../../assets/newdesign/myprofile/roundRightArrow.svg"
										alt=""
									/>
								</div>
								<div
									class="flex-1 d-flex align-items-center justify-content-between gap-2 interview-card pointer"
									@click="
										!hasAccess()
											? openLoginModal()
											: goToInterviewPrep(selectedJob)
									"
								>
									<div class="flex-1 d-flex align-items-center gap-3">
										<img
											src="../../assets/newdesign/jobsearch/preopInter.svg"
											alt=""
										/>
										<div>
											<div class="fam-mont fw-M fs-14 text-blue">
												Prepare for Interview
											</div>
											<div class="fam-lato fw-R fs-12 text-headtext mt-1">
												Learn practical, in-demand skills to stay ahead in your
												career journey.
											</div>
										</div>
									</div>
									<img
										height="24"
										width="24"
										src="../../assets/newdesign/myprofile/roundRightArrow.svg"
										alt=""
									/>
								</div>
							</div>
						</template>
						<template
							v-if="
								(!relatedAssessments || relatedAssessments.length) &&
								!jobShimmer &&
								!selectedJob.customFields.gov_job
							"
						>
							<div class="mb-black-bold mt-3">
								Assessments to practice for this job
							</div>
							<div v-if="!relatedAssessments" class="d-flex mt-2">
								<AssessmentCardSkeleton
									v-for="assess in 2"
									:key="assess"
									customClass="assesspro-cards mr-13px"
									:isMobile="false"
								/>
							</div>
							<div v-else class="js-carousel-parent mt-2" style="height: 180px">
								<b-carousel
									id="carousel-1"
									:interval="400000"
									:controls="relatedAssessments.length < 2 ? false : true"
									background="#ffffff"
									img-width="1024"
									img-height="480"
									@sliding-start="onSlideStart"
									@sliding-end="onSlideEnd"
								>
									<b-carousel-slide
										v-for="slideNumber in ceil(relatedAssessments.length / 2)"
										:key="slideNumber"
									>
										<AssessmentCard
											v-for="(assessment, index) in slice(
												relatedAssessments,
												(slideNumber - 1) * 2,
												(slideNumber - 1) * 2 + 2
											)"
											:key="index"
											:assessment="assessment"
											fromJobSearch="details"
											:fromSidepanel="true"
											class="carousel-assesspro-cards-1 mb-0"
											:class="index % 2 === 0 ? 'mr-3' : ''"
										/>
									</b-carousel-slide>
								</b-carousel>
							</div>
						</template>
						<template
							v-if="
								(!relatedJobs || relatedJobs.length) &&
								!jobShimmer &&
								!selectedJob.customFields.gov_job
							"
						>
							<div class="mb-black-bold mt-2">
								Similar jobs you might be looking for
							</div>
							<div v-if="!relatedJobs" class="d-flex flex-wrap mt-2">
								<div
									v-for="assess in 2"
									:key="assess"
									class="assesspro-cards"
									:class="assess % 2 == 0 ? '' : 'mr-13px'"
								>
									<div class="d-flex">
										<div style="height: 31px; width: 31px">
											<b-skeleton
												class="h-100 w-100"
												type="avatar"
											></b-skeleton>
										</div>
										<div class="width-93 1 pl-2">
											<b-skeleton class="w-50"></b-skeleton>
											<b-skeleton class="w-100"></b-skeleton>
										</div>
									</div>
									<hr />
									<div class="w-100">
										<b-skeleton class="w-100"></b-skeleton>
									</div>
								</div>
							</div>
							<div v-else class="js-carousel-parent-2 mt-2">
								<b-carousel
									:controls="relatedJobs.length < 2 ? false : true"
									id="carousel-1"
									:interval="400000"
									background="#ffffff"
									img-width="1024"
									img-height="480"
									@sliding-start="onSlideStart"
									@sliding-end="onSlideEnd"
								>
									<b-carousel-slide
										v-for="slideNumber in ceil(relatedJobs.length / 2)"
										:key="slideNumber"
									>
										<div
											v-for="(job, index) in slice(
												relatedJobs,
												(slideNumber - 1) * 2,
												(slideNumber - 1) * 2 + 2
											)"
											:key="index"
											class="carousel-assesspro-cards-2 mb-0 pointer"
											:class="index % 2 === 0 ? 'mr-3' : ''"
											@click.stop="onCarouselJobClick(job)"
										>
											<div class="d-flex">
												<div>
													<img
														src="../../assets/newdesign/jobsearch/roundJobDp.svg"
														alt=""
													/>
												</div>
												<div class="pl-2 width-93">
													<div
														class="d-flex justify-content-between align-items-center w-100"
													>
														<div
															class="mb-blue-txt-3 text-truncate text-left w-75 text-capitalize"
														>
															{{ toTitleCase(job.title) }}
														</div>
														<div
															@click.stop="
																!hasAccess()
																	? openLoginModal()
																	: toggleBookmark(job)
															"
															:class="index % 2 === 0 ? '' : 'mr-2'"
														>
															<img
																v-if="job.bookmarked"
																class="pointer"
																src="../../assets/newdesign/jobsearch/filledBookmark.svg"
																alt=""
															/>
															<img
																v-else
																class="pointer"
																src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
																alt=""
															/>
														</div>
													</div>
													<div class="mb-mobile-txt text-left mt-2">
														{{
															job.customFields.private_job
																? job.customFields.Board_Organization
																: job.customerName
														}}
													</div>
													<div
														class="d-flex align-items-center cd-hs-pi-sh-2 mt-2"
													>
														<div class="max-w45 text-truncate">
															{{ arrayToString(job.location) }}
														</div>
														<div class="mb-dot ml-2 mr-2"></div>
														<div class="max-w45 text-truncate">
															{{ toTitleCase(job.jobType) }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</b-carousel-slide>
								</b-carousel>
							</div>
						</template>
					</div>
				</div>
			</Transition>
			<Transition name="slide">
				<div
					v-if="showJobMatch"
					ref="job-details"
					class="w-50 jdprog-trans-main-cont"
				>
					<div
						class="d-flex align-items-center justify-content-between position-relative"
					>
						<img
							@click="showJobMatch = false"
							class="transArrow-pos"
							src="../../assets/newdesign/jdprogress/transBackArrow.svg"
							alt=""
						/>

						<div class="candash-modal-label-3 pl-4">Check Job Match</div>
						<div class="d-flex align-items-center">
							<div class="asp-vertical-line ml-3 mr-3"></div>
							<div @click="showJobMatch = false">
								<img
									class="pointer"
									src="../../assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
					<hr class="hr-back" />
					<JobMatch ref="job-details" :job="jobToMatch" />
				</div>
			</Transition>
			<Transition name="slide">
				<div
					v-if="showSidePanel && selectedJob && selectedJob.isCurated"
					ref="job-details"
					class="w-50 jdprog-trans-main-cont"
				>
					<div
						class="d-flex align-items-center justify-content-between position-relative"
					>
						<img
							@click="toggleSidePanel"
							class="transArrow-pos"
							src="../../assets/newdesign/jdprogress/transBackArrow.svg"
							alt=""
						/>

						<div class="candash-modal-label-3 pl-4">Job Details</div>
						<div class="d-flex align-items-center" v-if="!jobShimmer">
							<div
								class="asp-vertical-line ml-3 mr-3"
								v-if="selectedJob.jobApplied"
							></div>
							<div>
								<img
									@click="toggleSidePanel"
									class="pointer"
									src="../../assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
					<hr class="hr-back" />
					<div class="jdp-trans-overflow-2 w-100 pl-1">
						<div class="d-flex w-100 pl-3">
							<div style="height: 35px; width: 35px" v-if="jobShimmer">
								<b-skeleton class="h-100 w-100" type="avatar"></b-skeleton>
							</div>
							<div v-else>
								<img
									src="../../assets/newdesign/jdprogress/trans-DP.svg"
									alt=""
								/>
							</div>
							<div class="ml-3 width-94">
								<div
									class="d-flex align-items-start justify-content-between w-100"
								>
									<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
									<div class="jdp-black-txt-3 text-break w-60" v-else>
										{{
											toTitleCase(
												selectedJob.title || selectedJob.caption || "N/A"
											)
										}}
									</div>
									<div
										class="d-flex align-items-center gap-3 pr-2"
										v-if="!jobShimmer"
									>
										<b-button
											v-if="
												!selectedJob.jobApplied && !selectedJob.addedByRecruiter
											"
											@click="
												!hasAccess()
													? openLoginModal()
													: (selectedJob.customFields &&
															selectedJob.customFields.gov_job) ||
													  (selectedJob.customFields &&
															selectedJob.customFields.private_job)
													? openGovtJobModal(selectedJob)
													: openApplyJobModal(selectedJob)
											"
											class="candash-addBtn-js"
											style="padding: 4px 18px !important"
										>
											Apply

											<img
												class="ml-2"
												src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
												alt=""
										/></b-button>
										<b-button
											v-else
											class="candash-addBtn-js"
											style="padding: 4px 18px !important"
										>
											<img
												class="mr-2"
												src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
												alt=""
											/>
											Applied
										</b-button>
									</div>
								</div>
								<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
								<div class="cd-hs-pi-sh-2 d-flex align-items-start mt-2" v-else>
									<div
										class="d-flex align-items-center mr-4 max-w60 text-break"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-location.svg"
											alt=""
										/>
										{{
											selectedJob.location.length > 0
												? selectedJob.location[0]
												: selectedJob.location || "N/A"
										}}
										<span
											v-if="selectedJob.location.length > 1"
											@click="scrollToChild('child2')"
											class="viewmore-grey ml-1 pointer"
											>+{{ selectedJob.location.length - 1 }} more</span
										>
									</div>
								</div>
							</div>
						</div>

						<section
							class="jobapply-box d-flex align-items-center mt-3"
							v-if="getgovtids.includes(selectedJob.jobID)"
						>
							<div class="w-84">
								<div class="mb-black-bold-4">Did you Apply?</div>
								<div class="jobapplysubtext">
									Let us know and we will help you track your application
								</div>
							</div>
							<div class="w-8 text-center">
								<div class="jobapplybox-btns pointer" @click="appliedGovtjob()">
									Yes
								</div>
							</div>
							<div class="w-8 text-center">
								<div
									class="jobapplybox-btns pointer"
									@click="removeGovtid(selectedJob.jobID)"
								>
									No
								</div>
							</div>
						</section>
						<b-skeleton class="w-33 mt-3" v-if="jobShimmer"></b-skeleton>
						<div class="mb-black-bold-4 mt-4" v-else>Job Description</div>
						<b-skeleton class="w-100 h-30 mt-3" v-if="jobShimmer"></b-skeleton>
						<div
							v-else
							class="mb-grey-txt-2 pr-3 mb-2"
							v-html="selectedJob.description"
						></div>
						<template v-if="jobShimmer">
							<div class="d-flex w-100 justify-content-between">
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
							</div>
							<hr class="hr-back" />
							<div class="d-flex w-100 justify-content-between">
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
								<div class="w-50">
									<b-skeleton class="w-33 mt-3"></b-skeleton>
									<b-skeleton class="w-50 mt-3"></b-skeleton>
								</div>
							</div>
						</template>
						<template v-if="!jobShimmer">
							<div class="d-flex">
								<div
									class="w-50"
									v-if="selectedJob.minSalary && selectedJob.minSalary > 0"
								>
									<div class="mb-black-bold">Minimum CTC</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.minSalary }} LPA
									</div>
								</div>
								<div
									class="w-50"
									v-if="selectedJob.maxSalary && selectedJob.maxSalary > 0"
								>
									<div class="mb-black-bold">Maximum CTC</div>
									<div class="mb-grey-txt-2 mt-1">
										{{ selectedJob.maxSalary }} LPA
									</div>
								</div>
							</div>

							<hr class="hr-back" />
							<div ref="child2" class="mb-black-bold">Locations</div>
							<div class="mb-grey-txt-2 mt-1">
								{{ arrayToString(selectedJob.location) }}
							</div>
						</template>
						<template
							v-if="
								(!relatedAssessments || relatedAssessments.length) &&
								!jobShimmer &&
								!(selectedJob.customFields && selectedJob.customFields.gov_job)
							"
						>
							<div class="mb-black-bold mt-3">
								Assessments to practice for this job
							</div>
							<div v-if="!relatedAssessments" class="d-flex flex-wrap mt-2">
								<div
									v-for="assess in 2"
									:key="assess"
									class="assesspro-cards"
									:class="assess % 2 == 0 ? '' : 'mr-13px'"
								>
									<div class="d-flex">
										<div style="height: 31px; width: 31px">
											<b-skeleton
												class="h-100 w-100"
												type="avatar"
											></b-skeleton>
										</div>
										<div class="width-93 1 pl-2">
											<b-skeleton class="w-50"></b-skeleton>
											<b-skeleton class="w-100"></b-skeleton>
										</div>
									</div>
									<hr />
									<div class="w-100">
										<b-skeleton class="w-100"></b-skeleton>
									</div>
								</div>
							</div>
							<div v-else class="js-carousel-parent mt-2" style="height: 180px">
								<b-carousel
									id="carousel-1"
									:interval="400000"
									:controls="relatedAssessments.length < 2 ? false : true"
									background="#ffffff"
									img-width="1024"
									img-height="480"
									@sliding-start="onSlideStart"
									@sliding-end="onSlideEnd"
								>
									<b-carousel-slide
										v-for="slideNumber in ceil(relatedAssessments.length / 2)"
										:key="slideNumber"
									>
										<AssessmentCard
											v-for="(assessment, index) in slice(
												relatedAssessments,
												(slideNumber - 1) * 2,
												(slideNumber - 1) * 2 + 2
											)"
											:key="index"
											:assessment="assessment"
											:fromAsmntprogress="false"
											fromJobSearch="details"
											:fromSidepanel="true"
											class="mb-0"
											:class="index % 2 === 0 ? 'mr-3' : ''"
											style="width: 49%"
										/>
									</b-carousel-slide>
								</b-carousel>
							</div>
						</template>
						<template
							v-if="
								(!relatedJobs || relatedJobs.length) &&
								!jobShimmer &&
								!(selectedJob.customFields && selectedJob.customFields.gov_job)
							"
						>
							<div class="mb-black-bold mt-2">
								Similar jobs you might be looking for
							</div>
							<div v-if="!relatedJobs" class="d-flex flex-wrap mt-2">
								<div
									v-for="assess in 2"
									:key="assess"
									class="assesspro-cards"
									:class="assess % 2 == 0 ? '' : 'mr-13px'"
								>
									<div class="d-flex">
										<div style="height: 31px; width: 31px">
											<b-skeleton
												class="h-100 w-100"
												type="avatar"
											></b-skeleton>
										</div>
										<div class="width-93 1 pl-2">
											<b-skeleton class="w-50"></b-skeleton>
											<b-skeleton class="w-100"></b-skeleton>
										</div>
									</div>
									<hr />
									<div class="w-100">
										<b-skeleton class="w-100"></b-skeleton>
									</div>
								</div>
							</div>
							<div v-else class="js-carousel-parent-2 mt-2">
								<b-carousel
									:controls="relatedJobs.length < 2 ? false : true"
									id="carousel-1"
									:interval="400000"
									background="#ffffff"
									img-width="1024"
									img-height="480"
									@sliding-start="onSlideStart"
									@sliding-end="onSlideEnd"
								>
									<b-carousel-slide
										v-for="slideNumber in ceil(relatedJobs.length / 2)"
										:key="slideNumber"
									>
										<div
											v-for="(job, index) in slice(
												relatedJobs,
												(slideNumber - 1) * 2,
												(slideNumber - 1) * 2 + 2
											)"
											:key="index"
											class="carousel-assesspro-cards-2 mb-0 pointer"
											:class="index % 2 === 0 ? 'mr-3' : ''"
											@click.stop="onCarouselJobClick(job)"
										>
											<div class="d-flex">
												<div>
													<img
														src="../../assets/newdesign/jobsearch/roundJobDp.svg"
														alt=""
													/>
												</div>
												<div class="pl-2 width-93">
													<div
														class="d-flex justify-content-between align-items-center w-100"
													>
														<div
															class="mb-blue-txt-3 text-truncate text-left w-75 text-capitalize"
														>
															{{ toTitleCase(job.title) }}
														</div>
														<div
															@click.stop="
																!hasAccess()
																	? openLoginModal()
																	: toggleBookmark(job)
															"
															:class="index % 2 === 0 ? '' : 'mr-2'"
														>
															<img
																v-if="job.bookmarked"
																class="pointer"
																src="../../assets/newdesign/jobsearch/filledBookmark.svg"
																alt=""
															/>
															<img
																v-else
																class="pointer"
																src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
																alt=""
															/>
														</div>
													</div>
													<div class="mb-mobile-txt text-left mt-2">
														{{
															job.customFields.private_job
																? job.customFields.Board_Organization
																: job.customerName
														}}
													</div>
													<div
														class="d-flex align-items-center cd-hs-pi-sh-2 mt-2"
													>
														<div class="max-w45 text-truncate">
															{{ arrayToString(job.location) }}
														</div>
														<div class="mb-dot ml-2 mr-2"></div>
														<div class="max-w45 text-truncate">
															{{ toTitleCase(job.jobType) }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</b-carousel-slide>
								</b-carousel>
							</div>
						</template>
					</div>
				</div>
			</Transition>
		</div>

		<PaymentComingSoonModal :showModal.sync="showPaymentComingSoonModal" />
		<b-modal
			id="completeyourprofile"
			v-model="showCompleteProfileModal"
			size="md"
			centered
			hide-footer
			hide-header
			@hidden="showCompleteProfileModal = false"
		>
			<div class="p-2">
				<div class="cyp-container-top cyp-header-txt">
					<div class="d-flex justify-content-end pt-2 pr-2">
						<img
							class="rotate-on-hover pointer"
							src="../../assets/newdesign/jobsearch/whitecross.svg"
							alt=""
							@click="showCompleteProfileModal = false"
						/>
					</div>
					Complete your <br />
					profile
					<div class="cyp-dp-pos">
						<img src="../../assets/newdesign/jobsearch/cmp-dp.svg" alt="" />
					</div>
				</div>
				<div class="w-100 d-flex flex-column align-items-center">
					<div class="cyp-italic-txt">
						To apply for this job, please complete your resume first.
					</div>
					<div class="cyp-black-txt my-4">
						Creating a resume on our platform is quick and easy, and it will
						allow <br />
						you to showcase your skills and experience to potential employers.
					</div>
					<div class="mb-3">
						<b-button @click="goToDashboard" class="candash-addBtn"
							>Create your resume now</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal
			id="withdrawapplicationmodal"
			size="md"
			centered
			hide-footer
			hide-header
			v-model="showWithdrawApplicationModal"
			v-if="showWithdrawApplicationModal"
			@hidden="showWithdrawApplicationModal = false"
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="../../assets/newdesign/jdprogress/withdrawAppDP.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head">Withdraw Application</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									:class="{ 'opac-5': buttonLoader }"
									@click="
										!buttonLoader && (showWithdrawApplicationModal = false)
									"
								>
									<img
										class="rotate-on-hover"
										src="../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3">
								Are you sure you want to withdraw
								<span style="color: #20639b"
									>"{{ toTitleCase(selectedJob.title) }}"</span
								>
								application?
							</div>
						</div>
					</div>

					<div
						class="p-3 no-border-top d-flex align-items-center justify-content-end"
					>
						<b-button
							class="candash-cancelBtn mr-4"
							:class="{ 'opac-5': buttonLoader }"
							@click="!buttonLoader && (showWithdrawApplicationModal = false)"
							>Cancel</b-button
						>

						<div class="position-relative">
							<b-button
								:class="
									buttonLoader
										? 'candash-addBtn loader-class-withdraw defaultCursor'
										: 'candash-addBtn'
								"
								@click="!buttonLoader && withdrawApplication(selectedJob)"
								>{{ buttonLoader ? "" : "Withdraw" }}</b-button
							>
							<div v-if="buttonLoader" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="withdrawapplicationmodal"
			size="md"
			centered
			hide-footer
			hide-header
			v-model="showCannotWithdrawApplicationModal"
			v-if="showCannotWithdrawApplicationModal"
			@hidden="showCannotWithdrawApplicationModal = false"
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="../../assets/newdesign/jdprogress/withdrawAppDP.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head">
									Cannot Withdraw Application
								</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="showCannotWithdrawApplicationModal = false"
								>
									<img
										class="rotate-on-hover"
										src="../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3">
								The application for this job has already been selected, so you
								cannot withdraw it.
							</div>
						</div>
					</div>

					<div
						class="p-3 no-border-top d-flex align-items-center justify-content-end"
					>
						<b-button
							class="candash-addBtn"
							@click="showCannotWithdrawApplicationModal = false"
							>Okay</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
		<ApplyJobModal
			v-if="selectedJob && showApplyJob"
			@close="showApplyJob = false"
			@success="handleJobApplicationSuccess"
			@failure="errorModal('Error', $event), (showApplyJob = false)"
			:job="selectedJob"
			:candidateData="candidateData"
			:licenseKey="selectedJob.licenseKey"
		/>
		<TestDetails
			ref="testDetails"
			v-if="showTestDetails == true"
			:public="true"
			:selectedAssessment="selectedAssessment"
			:showTestDetails="showTestDetails"
			@closeTestModal="showTestDetails = false"
			@purchase-success="handlePurchaseSuccess"
		/>
		<LaptopJobPref
			v-if="showJobPreferance"
			:showModal="showJobPreferance"
			:modalId="'jobprefernce'"
			@close-modal="showJobPreferance = false"
		/>
		<Govtjobs
			v-if="govtJobModal"
			@storeid="storeGovtId"
			:showmodal="govtJobModal"
			:selectedJob="selectedJob"
			@close-modal="govtJobModal = false"
		/>
		<div style="display: none" ref="responseContainer"></div>
		<FormModal
			v-if="showForm"
			:showModal="showForm"
			:formType="formType"
			:form="selectedForm"
			:fromJobSearch="true"
			@data-added="refreshCandidateInfo"
			@skip-modal="handleDismissModal"
			@close-modal="showForm = false"
		/>
	</div>
</template>

<script>
import { required, email, maxLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import jobSearch from "@/components/mixin/jobSearch.js";
import ApplyJobModal from "@/components/JobSearch/applyJob.vue";
import Govtjobs from "@/components/JobSearch/GovtJobs.vue";
import toast from "@/components/mixin/toast";
import TestDetails from "../AssessmentProgress/TestDetailsAP.vue";
import FormTags from "@/components/InputComponents/FormTags.vue";
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import InputField from "@/components/InputComponents/Input.vue";
import EventBus from "../../utils/EventBus";
import Loader from ".././../components/fixedcomponents/Loader.vue";
import JobMatch from "@/components/JobSearch/JobMatch.vue";
import LaptopJobPref from "./LaptopJobPref.vue";
import JobAlert from "./JobAlert.vue";
import FormModal from "@/components/BuilderPage/FormModal.vue";
import {
	getPublicAssessments,
	getSearchHistory,
	applyJob,
	getCandidateFilePaths,
	applyCuratedJobs,
	getCandidatePrimaryProfile,
	getCandidateOnboard,
} from "../../utils/apiFunctions.js";
import { getCustomFields } from "../../utils/customField.js";
import { trackJobApplied } from '@/utils/posthogHelpers';
import { hasAccess } from "@/utils/tokenCheck";
import { getCandidateDetail } from "../../controllers/dashboard/asynchronous";
import payment from "@/components/mixin/payment";

import AssessmentCard from "@/components/Assessment/AssessmentCard.vue";

import AssessmentCardSkeleton from "../../components/Assessment/AssessmentCardSkeleton.vue";

export default {
	name: "LaptopJobSearch",
	components: {
		TestDetails,
		ApplyJobModal,
		Loader,
		FormTags,
		SelectCustom,
		JobMatch,
		LaptopJobPref,
		Govtjobs,
		InputField,
		AssessmentCard,
		AssessmentCardSkeleton,
		JobAlert,
		FormModal,
	},
	mixins: [jobSearch, toast, payment],

	data() {
		return {
			showJobMatch: false,
			jobMatchData: [],
			showJobPreferance: false,
			loopvar: 10,
			loopvar2: 2,
			slide: 0,
			sliding: null,
			assessments: null,
			assessLoader: true,
			selectedAssessment: {},
			newObject: {},
			customFieldsArray: [],
			touchedFields: [],
			showTestDetails: false,
			jobShimmer: false,
			showPreferences: false,
			filtervalues: [
				"Sort by",
				"Posted Date",
				"Experience Level",
				"Work Type",
				"Job Type",
				"Salary",
				"Top Companies",
				"Industry",
				"Education",
				"Notice Period",
				"Company Type",
				"Location",
			],
			options: [
				{ text: "Orange", value: "orange" },
				{ text: "Apple", value: "apple" },
				{ text: "Pineapple", value: "pineapple" },
				{ text: "Grape", value: "grape" },
				{ text: "Orange", value: "orange" },
				{ text: "Apple", value: "apple" },
				{ text: "Pineapple", value: "pineapple" },
				{ text: "Grape", value: "grape" },
				{ text: "Orange", value: "orange" },
				{ text: "Apple", value: "apple" },
				{ text: "Pineapple", value: "pineapple" },
				{ text: "Grape", value: "grape" },
			],
			searchHistory: [],
			email: null,
			showForm: false,
			selectedForm: null,
			formType: "add",
			formCheckTimeout: null,
			// isManualClear: false,
		};
	},
	props: {
		resumeModal: Boolean,
	},
	created() {
		this.initCreatedLogic();
		if (this.hasAccess()) {
			this.refreshCandidateInfo();
		}

		EventBus.$on("search", (search) => {
			if (this.showBookmarked) {
				this.searchJobs(search, false);
			} else {
				this.getJobs(false, true, search);
			}
		});

		EventBus.$on("login-success", this.handleLoginSuccess);
		EventBus.$on("onboarding-fetch-post-login", this.handleLoginSuccess);
		// EventBus.$on("clear-inner-search", () => {
		// 	this.tempSearchQuery = "";
		// 	this.searchQuery = "";
		// 	this.search = "";
		// 	// this.isManualClear = true;
		// });
	},

	mounted() {
		this.initMountedLogic();
	},
	beforeDestroy() {
		if (this.formCheckTimeout) clearTimeout(this.formCheckTimeout);
		this.searchQuery = "";
		this.tempSearchQuery = "";
		this.search = "";
		this.page = 0;
		EventBus.$off("search", this.onSearch);
		EventBus.$off("login-success", this.handleLoginSuccess);
		EventBus.$off("onboarding-fetch-post-login", this.handleLoginSuccess);
		// EventBus.$off("clear-inner-search");
	},
	computed: {
		newobjectskillsStringArray() {
			// Convert array of objects into array of strings
			// console.log(this.primaryCandidateInfo,"hiiii");

			return this.primaryCandidateInfo.skills.map((obj) => obj.skillName);
		},
		...mapGetters("userVUEX", {
			userinfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			primaryCandidateInfo: "getPrimaryCandidateInfo",
			getgovtids: "getgovtids",
		}),

		filteredTabs() {
			if (this.currentTab === "hire") {
				return this.FILTER_TABS;
			}
			return Object.fromEntries(
				Object.entries(this.FILTER_TABS).filter(([key]) => key === "minSalary")
			);
		},
	},

	methods: {
		handlePurchaseSuccess() {
			this.assessment.purchased = true;
		},
		hasAccess() {
			return hasAccess();
		},
		async handleLoginSuccess() {
			await this.initCreatedLogic();
			this.initMountedLogic();
			this.$forceUpdate();
		},
		initCreatedLogic() {
			this.getSearchHistoryData();
			this.getPreferences();

			if (this.$route.query.searchQuery) {
				this.search = this.$route.query.searchQuery;
				this.tempSearchQuery = query;
			}
		},

		initMountedLogic() {
			this.$nextTick(() => {
				const el = this.$refs["laptop-job-search"];
				if (el) {
					el.removeEventListener("click", this.handleDocumentClick); // prevent duplicate
					el.addEventListener("click", this.handleDocumentClick);
				}
			});
			if (this.hasAccess()) {
				this.formCheckTimeout = setTimeout(() => {
					this.checkAndOpenFormModal();
				}, 10000);
			}
		},
		async checkAndOpenFormModal() {
			// if (!this.primaryCandidateInfo) return;
	try {
				const onboardRes = await getCandidateOnboard();
				const onboardData = onboardRes?.data?.data;
				if (onboardData?.onboardingCompleted === false) {
					return;
				}
			} catch (err) {
				console.error("[LaptopJobSearch] getCandidateOnboard error:", err);
			}
			// Check if modal was dismissed in the last hour
			const lastDismissed = localStorage.getItem("lastDismissedProfileModal");
			const oneHour = 60 * 60 * 1000;
			if (lastDismissed && Date.now() - parseInt(lastDismissed) < oneHour) {
				return;
			}

			// Do not show profile modals if onboarding is still in progress
		

			const info = this.primaryCandidateInfo;
			const expLevel = info.experienceLevel;

			if (
				expLevel === "fresher" &&
				(!info.educationalInfo || info.educationalInfo.length === 0)
			) {
				this.selectedForm = {
					formID: "education",
					formName: "Educational Info",
					selectedTabOnCrud: "education",
				};
				this.formType = "add";
				this.showForm = true;
			} else if (
				expLevel &&
				expLevel !== "fresher" &&
				(!info.experience || info.experience.length === 0)
			) {
				this.selectedForm = {
					formID: "experience",
					formName: "Experience Info",
					selectedTabOnCrud: "experience",
				};
				this.formType = "add";
				this.showForm = true;
			}
		},
		handleDismissModal() {
			this.showForm = false;
			localStorage.setItem("lastDismissedProfileModal", Date.now().toString());
		},
		async refreshCandidateInfo() {
			try {
				// Use no-id endpoint to always fetch the primary profile, not a stale per-profile id from the store.
				const res = await getCandidatePrimaryProfile();
				if (res.status === 200 && res.data.data) {
					this.$store.commit("candidateVUEX/setPrimaryProfile", res.data.data);
				}
			} catch (error) {
				console.error("Error refreshing candidate info:", error);
			}
		},
		gobacktoPrevpage() {
			if (this.$route.query.from === "resumeclinicModal") {
				if (this.$route.query.fromPage === "ProfileVisibility") {
					this.$router.push({
						name: "ProfileVisibility", // navigate to the page
						query: {
							from: "resumeclinicModal", // keep the existing data
						},
					});
					return;
				}
				this.$router.push({
					name: "MyProfile",
					query: {
						from: "resumeclinicModal",
					},
				});
			} else {
				this.$router.go(-1);
			}
		},
		jobSearch(searchTerm) {
			console.log("search term", searchTerm);
			this.tempSearchQuery = searchTerm;
			this.bookmarkedSearchQuery = searchTerm;
			this.applyFilter();
		},
		openJobMatch() {
			this.showJobMatch = true;
		},

		storeGovtId(id) {
			console.log(id);
			this.$store.commit("candidateVUEX/storegovtids", id);
		},
		removeGovtid(id) {
			this.$store.commit("candidateVUEX/removegovtid", id);
		},
		async appliedGovtjob(jobid,job) {
			try {
				if (this.selectedJob.isCurated) {
					await applyCuratedJobs({ jobID: this.selectedJob.jobID });
					this.selectedJob.jobApplied = true;
					this.removeGovtid(this.selectedJob.jobID);
					this.successModal("Success", "Applied Successfully");
					this.page = 0;
					this.jobs = null;
					await this.getCuratedJobs();
					return;
				}
				const customFields = await getCustomFields(
					"5",
					"add",
					this.selectedJob.licenseKey
				);
				if (customFields.length) {
					[this.customFieldsArray, this.newObject, this.touchedFields] =
						customFields;
				}

				// Prepare candidate info mappings
				const candidateInfo = this.primaryCandidateInfo;
				const res1 = await getCandidateFilePaths(this.primaryCandidateInfo._id);
				if (res1.status == 200) {
					candidateInfo.resume = res1.data.data.resumePath;
				}
				// Populate the `newObject` with candidate information
				const keys = Object.keys(this.newObject.customFields);
				Object.assign(this.newObject, {
					resume: candidateInfo.resume,
					email: candidateInfo.email,
					experince: candidateInfo.totalYearsOfExp,
					name: candidateInfo.fullName,
					phoneNumber: candidateInfo.phoneNumber,
					skills:
						this.primaryCandidateInfo.skills.length > 0
							? this.newobjectskillsStringArray
							: [],
					otherSource: "Hire3x",
					source: "other",
					customFields: {
						...this.newObject.customFields,
						altPhoneNumber: candidateInfo.altPhoneNumber,
						currentCTC: candidateInfo.currentCTC,
						expectedCTC: candidateInfo.expectedCTC,
						gender: candidateInfo.gender,
						willingToRelocate: candidateInfo.willingToRelocate,
						willingToRelocateTo: candidateInfo.willingToRelocateTo,
						noticePeriod: candidateInfo.noticePeriod,
					},
				});
				const payload = {
					emailID: candidateInfo.email,
					jobID: jobid,
					firstName: candidateInfo.firstName,
					lastName: candidateInfo.lastName,
					location: candidateInfo.city,
					phoneNumber: candidateInfo.phoneNumber,
					candidateInfo: {
						...this.newObject,
						userID: this.userinfo.userID,
					},
				};
				console.log(payload);

				// Uncomment to apply for the job and handle the response
				const res = await applyJob(payload);
				if (res.status === 200) {
					// this.$emit("success", jobid);
					trackJobApplied(job)
					this.handleJobApplicationSuccess(jobid);
					this.removeGovtid(jobid);
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error("Error in appliedgovtjob:", error);
			}
		},

		// storegovtids(val) {
		// 	if (!this.openedgovtlink.includes(this.selectedJob.jobID)) {
		// 		this.openedgovtlink.push(val);
		// 		this.removeGovtid();
		// 	}

		// 	console.log(this.openedgovtlink);
		// },
		async getSearchHistoryData() {
			try {
				const res = await getSearchHistory();
				if (res.status == 200) {
					this.searchHistory = res.data.data;
				} else {
					throw new Error("No search history found");
				}
			} catch (error) {
				console.error(error);
				this.searchHistory = [];
			} finally {
				this.getPublicAssessments();
			}
		},
		async getPublicAssessments() {
			// this.shimmer = true;
			// this.isManualClear = false;
			try {
				const res = await getPublicAssessments({
					page: 0,
					count: 9,
					email: this.userinfo.email,
					home: true,
				});
				if (res.status == 200) {
					this.assessments = res.data.data.data.filter(
						(assessment) => assessment.attemptsLeft >= 1
					);
					console.log(this.searchHistory);
					if (this.searchHistory.length == 0) {
						this.assessments = this.assessments.slice(0, 2);
					} else {
						this.assessments = this.assessments.slice(0, 3);
					}
				} else {
					this.assessments = [];
				}
			} catch (error) {
				this.assessments = [];
			} finally {
				this.assessLoader = false;
			}
		},

		handleDocumentClick(event) {
			if (!document.getElementById("app")?.contains(event.target)) return;
			if (this.showFilter && !this.$refs["filter"]?.contains(event.target)) {
				this.showFilter = false;
			}
			if (
				this.showSidePanel &&
				!this.$refs["job-details"]?.contains(event.target)
			) {
				this.showSidePanel = false;
			}
		},
		routeToTakeTest(data) {
			this.showTestDetails = true;
			this.selectedAssessment = JSON.parse(JSON.stringify(data));
		},

		checkbetween(x, min, max) {
			// Return `true` if `x` is between `min` and `max`, otherwise `false`.
			return x > min && x < max;
		},

		scrollToChild(childRef) {
			const target = this.$refs[childRef];

			if (target) {
				target.scrollIntoView({ behavior: "smooth" });
			}
		},

		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		highlightedSkills(skills) {
			const query = this.tempSearchQuery;
			const regex = new RegExp(`(${query})`, "gi");
			return skills
				.map((skill) =>
					skill.replace(regex, '<span class="highlight">$1</span>')
				)
				.join(", ");
		},
		highlightedSkillsDash(skill) {
			const query = this.tempSearchQuery;
			const regex = new RegExp(`(${query})`, "gi");
			return skill.replace(regex, '<span class="highlight">$1</span>');
		},
		onCarouselJobClick(job) {
			this.showJobDetails(job);
			this.$nextTick(() => {
				const element = document.querySelector(".js-selected-card");
				if (element) {
					element.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
				}
			});
		},
	},
	watch: {
		"$route.query.bookmarked"(bookmark) {
			this.scrollToTop();
			this.showBookmarked = bookmark || false;
			this.tempSearchQuery = "";
			this.bookmarkedSearchQuery = "";
			this.searchQuery = "";
			this.tempLocations = "";
			this.page = 0;
			this.resetFilterWithoutApply();
			this.showSidePanel = false;
			this.showFilter = false;
			this.jobs = null;
			if (this.showBookmarked) {
				this.getJobs(false, true);
			} else {
				this.getJobs(false);
			}
		},
	},
};
</script>

<style>
.js-main-container {
	height: calc(100vh - 154px);
	display: flex;
	justify-content: space-between;
}

.js-saved-left-cont {
	background-color: #ffffff;
	box-shadow: 0px 0px 14px 0px #c4c4c480;
	padding: 11px 14px 9px 0px;
}

.js-right-cont {
	height: calc(100vh - 83px);
	overflow-y: auto;
}

.js-left-cont {
	/* background-color: #ffffff; */
	/* box-shadow: 0px 0px 14px 0px #c4c4c480; */
	border-radius: 5px;
	height: calc(100vh - 83px);
	width: 70%;
	/* padding: 11px 14px 9px 0px; */
}

.js-right-cont::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.js-right-cont {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;
	/* Firefox */
}

@media (min-width: 1536px) {
	.js-search-cont {
		border: 1px solid #c4c4c4;
		border-radius: 15px;
		width: 78%;
		transition: all 0.3s linear;
	}
}

/* Media query for mobile view */
@media only screen and (max-width: 1535px) {
	.js-search-cont {
		border: 1px solid #c4c4c4;
		border-radius: 15px;
		width: 74%;
		transition: all 0.3s linear;
	}

	.font9px {
		font-size: 9px !important;
	}

	.font10px {
		font-size: 10px !important;
	}
}

@media only screen and (max-width: 1395px) {
	.font9px {
		font-size: 7px !important;
	}

	.font10px {
		font-size: 8px !important;
	}
}

.js-input .form-control {
	width: 100%;
	border-width: 0px 1px 0px 0px;
	border-style: solid;
	border-color: #c4c4c4;
	border-radius: 15px 0px 0px 15px;
	padding: 8px 9px 12px 35px;
	height: 34px;
}

.js-input .form-control:focus {
	box-shadow: none;
}

.js-input .form-control::placeholder {
	color: #72738e80;
}

.js-search-pos {
	position: absolute;
	top: 9px;
	left: 11px;
}

.js-overflow {
	height: calc(100vh - 260px);
	overflow: auto;
}

.js-overflow-empty {
	height: calc(100vh - 235px) !important;
}

.cand-dashboard-maincontainer.logout-cont .js-overflow-empty {
	height: calc(100vh - 258px) !important;
}

.js-overflow-2 {
	height: calc(100vh - 156px);
	overflow: auto;
	padding: 0 15px 0 15px;
}

.js-cards {
	border: 1px solid #8c8c8c54;
	width: 100%;
	border-radius: 8px;
	padding: 11px 10px 11px 14px;
}

.js-selected-card {
	border: 1px solid #8c8c8c54;
	background-color: #e1eef7;
	width: 100%;
	border-radius: 8px;
	padding: 11px 10px 11px 14px;
}

.js-trans-main-cont {
	position: absolute;
	width: 44%;
	height: calc(100vh - 90px);
	right: 2px;
	top: 14px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

.js-trans-top {
	padding: 20px 15px 12px 15px;
}

.js-trans-overflow {
	height: calc(100vh - 230px);
	display: flex;
	justify-content: space-between;
}

.js-trans-left {
	background-color: #e8eff4;
	border-radius: 4px;
	padding: 5px;
	width: 45%;
	height: 100%;
	overflow: auto;
}

.js-trans-right {
	width: 54%;
	border-radius: 4px;
	box-shadow: 0px 0.5px 10px 0px #28293d26;
	border: 0.5px solid #8c8c8c66;
	height: 100%;
	overflow: auto;
}

.js-normal-filter {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #344054;
	display: flex;
	align-items: center;
	padding: 10px;
}

.js-selected-filter {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #20639b;
	display: flex;
	align-items: center;
	padding: 10px;
	background-color: #ffffff;
	border-radius: 4px;
}

.js-blue-search-cards {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #ffffff;
	background-color: #3389a4;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 4px 7px;
	height: fit-content;
	min-width: auto;
	max-width: 100%;
	overflow: hidden;
}

.js-search-tag-text {
	display: block;
	flex: 1;
	min-width: 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.js-first-overflow {
	overflow: hidden;
	min-height: auto;
	max-height: 100px;
	z-index: 2;
	position: relative;
}

.js-first-overflow::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.js-first-overflow {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;
	/* Firefox */
}

.js-right-first-card {
	background: linear-gradient(313.47deg, #c1d3fe 0.05%, #d7e3fc 79.13%);
	position: relative;
	width: 100%;
	/* height: 145px; */
	border-radius: 8px;
	overflow: hidden;
}

.js-right-second-card {
	background: linear-gradient(296.7deg, #89c2d9 0.06%, #c4e3ed 100%);
	position: relative;
	width: 100%;
	height: 158px;
	border-radius: 8px;
	overflow: hidden;
}

.js-right-jobpref-card {
	background: #ffffff;
	position: relative;
	width: 100%;
	/* height: 158px; */
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #dedede;
}

.js-right-third-card {
	background: linear-gradient(
		133.18deg,
		rgba(187, 222, 251, 0.6) 13.05%,
		rgba(86, 174, 246, 0.6) 89.15%
	);
	border: 0.25px solid #cbcbcb;
	position: relative;
	width: 100%;
	/* height: 145px; */
	border-radius: 8px;
	overflow: hidden;
}

.firstside-pos {
	position: absolute;
	right: 0px;
	top: 0px;
	z-index: 1;
}

.js-right-input .form-control {
	background: #4a73d212;
	border: 1px solid #85a1e0;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border-radius: 8px;
	height: 30px;
	padding: 10px 10px 12px 10px;
	color: #332d2d !important;
	font-size: var(--size-12) !important;
	font-weight: 500 !important;
}

.js-right-input .form-control:focus {
	background: #4a73d212;
	border: 1px solid #85a1e0;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border-radius: 8px;
	height: 30px;
	padding: 10px 10px 12px 10px;
}

.js-assesspro-cards {
	background-color: #d8e9f7;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 100%;
	border: 0.5px solid #ffffff;
	margin-bottom: 12px;
	padding: 10px;
	border-radius: 5px;
	position: relative;
	z-index: 2;
}

.carousel-assesspro-cards-1 {
	background-color: #ffffff;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 49%;
	border: 1px solid #20639b33;
	margin-bottom: 12px;
	padding: 10px 10px 5px 10px;
	border-radius: 5px;
	position: relative;
	z-index: 2;
}

.carousel-assesspro-cards-2 {
	background-color: #f9fcfe;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 49%;
	border: 1px solid #20639b33;
	margin-bottom: 12px;
	padding: 15px 10px 15px 15px;
	border-radius: 8px;
	position: relative;
	z-index: 2;
}

.js-purple-card {
	background-color: #f4ebfe;
	width: 100%;
	min-height: 300px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	border-radius: 8px;
}

.js-carousel-parent-2 {
	height: 115px;
}

.js-carousel-parent {
	height: 143px;
}

.js-carousel-parent .carousel {
	height: 100%;
}

.js-carousel-parent .carousel-inner {
	height: 100%;
}

.js-carousel-parent .carousel-item.active {
	height: 100%;
}

.js-carousel-parent .carousel-caption {
	display: flex;
	justify-content: space-between;
	z-index: 1;
	left: 0px;
	padding: 0;
	width: 99%;
	height: 100%;
	bottom: 0px;
}

.js-carousel-parent .carousel-control-prev {
	width: 6%;
	left: -12px;
	opacity: 1;
	top: 57px;
	height: fit-content;
}

.js-carousel-parent .carousel-control-next {
	width: 6%;
	right: -3px;
	opacity: 1;
	top: 57px;
	height: fit-content;
}

.js-carousel-parent .carousel-control-prev-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselLeft.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	left: unset !important;
	position: absolute;
	top: unset !important;
}

.js-carousel-parent .carousel-control-next-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselRight.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	right: unset !important;
	position: absolute;
	top: unset !important;
}

.js-carousel-parent-2 .carousel {
	height: 100%;
}

.js-carousel-parent-2 .carousel-inner {
	height: 100%;
}

.js-carousel-parent-2 .carousel-item.active {
	height: 100%;
}

.js-carousel-parent-2 .carousel-caption {
	display: flex;
	justify-content: space-between;
	z-index: 1;
	left: 0px;
	padding: 0;
	width: 99%;
	height: 100%;
	bottom: 0px;
}

.js-carousel-parent-2 .carousel-control-prev {
	width: 6%;
	left: -12px;
	opacity: 1;
	top: 35px;
	height: fit-content;
}

.js-carousel-parent-2 .carousel-control-next {
	width: 6%;
	right: -3px;
	opacity: 1;
	top: 35px;
	height: fit-content;
}

.js-carousel-parent-2 .carousel-control-prev-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselLeft.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	left: unset !important;
	position: relative;
	top: unset !important;
}

.js-carousel-parent-2 .carousel-control-next-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselRight.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	right: unset !important;
	position: relative;
	top: unset !important;
}

.loader-pos-withdraw {
	position: absolute;
	top: -53px;
	z-index: 1;
	left: 20px;
}

.loader-class-withdraw {
	height: 31.5px !important;
	width: 130.5px !important;
	opacity: 0.5;
}

.highlight {
	font-weight: bold;
	background-color: yellow;
}

.jobref-border {
	position: absolute;
	top: 0;
	left: 0;
}

.jobref-topicon {
	position: absolute;
	top: 3px;
	right: 3px;
}

.jobpref-subheads {
	font-family: "Montserrat", sans-serif;
	font-style: italic;
	font-weight: 400;
	font-size: 13px;
	color: #4e4e4e;
}

.setupbtn {
	border-radius: 8px !important;
	padding: 3px 15px !important;
}

#jobprefernce .modal-body {
	padding: 0px !important;
}

#jobprefernce .modal-content {
	top: 30px !important;
}

#jobprefernce .modal-dialog {
	max-width: 950px !important;
}

.jobapply-box {
	padding: 10px;
	background: #ecf6ff;
	border-radius: 8px;
}

.jobapplysubtext {
	font-family: "Montserrat", sans-serif;
	font-style: italic;
	font-weight: 500;
	font-size: 14px;
	color: #8c8c8c;
}

.jobapplybox-btns {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #20639b;
}

.jobapplybox-btns:hover {
	background: #ffffff;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 12px;
	padding: 1px 5px;
	text-align: center;
}

.w-84 {
	width: 84%;
}

.w-8 {
	width: 8%;
}

.ja-govtjob-tag {
	padding: 3px 6px;
	background: rgba(3, 142, 0, 0.1);
	border-radius: 6px;
	font-family: "Montserrat", sans-serif;
	font-style: italic;
	font-weight: 500;
	font-size: 10px;
	color: #038e00;
}

.w-20 {
	width: 20%;
}

.interview-card {
	background: #ffffff;
	border: 1px solid #e3e6ea;
	border-radius: 8px;
	padding: 12px;
}

.new-custom-tab-sect {
	display: flex;
	gap: 12px;
	margin-bottom: 0;
	padding: 0;
	height: 56px;
}

.new-custom-tab-sect .tab {
	flex: 1;
	font-family: "Montserrat", sans-serif;
	height: 45px;
	padding: 0 24px;
	border: none;
	background: #f1f3f6;
	color: #8a97a6;
	font-weight: 600;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	transition: all 0.3s ease;
	font-size: 16px;
	z-index: 1;
}

/* Precise Glassmorphism for Inactive Tabs */
.new-custom-tab-sect .tab:not(.active) {
	height: 45px;
	background: radial-gradient(
			100% 100% at 0% 0%,
			rgba(255, 255, 255, 0.4) 0%,
			#ffffff 100%
		)
		/* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
	border-image-source: linear-gradient(
		169.15deg,
		#ffffff 0%,
		rgba(238, 237, 237, 0.5) 96.79%
	);
	backdrop-filter: blur(23.999998092651367px);
	box-shadow: -2.86px -2.86px 142.86px 0px #ffffff05 inset;
	border-radius: 8px;
}

.new-custom-tab-sect .tab.active {
	background: #20639b;
	color: #ffffff;
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
	z-index: 4;
	height: 56px;
}

.tab-icon {
	width: 20px;
	height: 20px;
	object-fit: contain;
}

.tab-body {
	background: #ffffff;
	padding: 0;
	box-shadow: 0px 0px 14px 0px #c4c4c480;
	border: 1px solid #20639b;
	margin-top: 1px;
	position: relative;
	z-index: 2;
	overflow: hidden;
}

.tab-body.hire-active {
	border-radius: 0px 12px 12px 12px;
}

.tab-body.curated-active {
	border-radius: 12px 0px 12px 12px;
}

/* Active tab covers the body border for seamless connection */
.new-custom-tab-sect .tab.active {
	margin-bottom: -1px;
}

/* MAGIC CURVE - Concave Corners (Figma Perfect) */
.new-custom-tab-sect .tab.active::before,
.new-custom-tab-sect .tab.active::after {
	content: "";
	position: absolute;
	bottom: 0px;
	width: 12px;
	height: 12px;
	background: #20639b;
	display: none;
	z-index: 5;
}

/* Curve for the first tab (RIGHT side) */
.new-custom-tab-sect .tab.active:first-child::after {
	display: block;
	right: -12px;
	-webkit-mask: radial-gradient(circle at 100% 0%, transparent 12px, #20639b 0);
	mask: radial-gradient(circle at 100% 0%, transparent 12px, #20639b 0);
}

/* Curve for the last tab (LEFT side) */
.new-custom-tab-sect .tab.active:last-child::before {
	display: block;
	left: -12px;
	-webkit-mask: radial-gradient(circle at 0% 0%, transparent 12px, #20639b 0);
	mask: radial-gradient(circle at 0% 0%, transparent 12px, #20639b 0);
}

/* Ensure the container's top-left/right radius is hidden when tab is at the edge */
.new-custom-tab-sect .tab.active:first-child {
	border-top-left-radius: 12px;
}

/* Seamless blend into the body */
.new-custom-tab-sect .tab.active {
	margin-bottom: -1px;
}

.Update-box {
	border: 1px solid #20639b26;
	border-radius: 8px;
	background: #eff6ff;
	padding: 8px 16px;
	font-family: Montserrat;
	font-weight: 600;
	font-size: 14px;
	color: #20639b;
}

.new-job-box {
	padding: 8px 13px;
	border-radius: 8px;
	font-family: Lato;
	font-weight: 600;
	color: #333333;
	font-size: 15px;
	background: #d7e3fc;
}

.on-act {
	font-family: Montserrat;
	font-weight: 400;
	font-size: 8px;
	color: #4b4b4b;
}

.candash-addBtn-js.up-btn {
	height: 25px;
	font-size: 12px !important;
}

.candash-addBtn-js.up-btn img {
	width: 10px;
	height: 10px;
}

.new-custom-tab-sect .tab.active .curated-icon {
	filter: brightness(0) invert(1);
}

.salary-button {
	border-radius: 50%;
	min-width: 32px;
	min-height: 32px;
	line-height: 1;
	color: #ffffff;
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
}

/* Prevent any state from changing text color */
.salary-button:hover,
.salary-button:focus,
.salary-button:active {
	color: #ffffff !important;
	outline: none !important;
	box-shadow: none !important;
}

.salary-input {
	border-radius: 4px;
	border: 1px solid #eaedf0;
}

.salary-button-disabled {
	background-color: #bac9d8;
}
.w-55 {
	width: 55%;
}
.w-30 {
	width: 30%;
}
</style>
